import './hevensSelect';
import './hevensSelect.scss';

export default el => $(el).hevensSelect({ disable_search: true });



// WEBPACK FOOTER //
// ./scripts/lib/select/initSelect.js